module.exports = __webpack_public_path__ + "img/petjy.3c4e9df6.png";